module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.eaf02c2d.png";